module.exports = function throttle(callback, limit) {
    var wait = false;
    return function() {
        if (!wait) {
            callback.apply(null, arguments);
            wait = true;
            setTimeout(function() {
                callback.apply(null, arguments);
                wait = false;
            }, limit);
        }
    };
};



// WEBPACK FOOTER //
// ./src/modules/throttle.js